import { JSX } from 'react';
import './style.scss';

function LinkListWithHeading({ heading, className, listItems }: { heading: string; className?: string; listItems: JSX.Element[] }) {
  return (
    <fieldset className={className}>
      <legend className="mb-0">
        <h2 className="h3">{heading}</h2>
      </legend>
      <div className="link-list-with-heading list-group list-group-flush border-top">
        {listItems.map((item, index) => {
          const isLastItem = index === listItems.length - 1;
          return (
            <div key={index} className={`link-list-with-heading__list-item--with-link list-group-item align-items-md-center ps-0 ${isLastItem ? 'border-bottom' : ''}`}>
              {item}
            </div>
          );
        })}
      </div>
    </fieldset>
  );
}

export default LinkListWithHeading;
